export default "__VITE_ASSET__DONr4fbj__"